const styles = () => ({
  mobileCreateFolderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '320px',
    margin: '0 auto',
    height: '100%',
    '&>div': {
      width: '100%',
    },
  },
  errorMessage: {
    fontSize: '12px',
    margin: '5px 0 0',
    color: '#FD6765',
  },
  searchWrapper: {
    position: 'relative',
    width: '100%',
  },
  searchIcon: {
    position: 'absolute',
    top: '0',
    left: '14px',
    height: '100%',
  },
});

export default styles;
